import { useState, useEffect, useContext } from "react";
import { v4 as uuid4 } from 'uuid';
import { Group, Conversation } from "../../admin.type";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  SimpleTableContainer,
} from "../../admin.styled";
import AdvanceSearch from "core/components/global/advanceSearch/advanceSearch";
import NoResultsFound from "core/components/global/tables/noResults/noResultsFound";
import { AdminConversationRow } from "./conversation";
import { AuthContext } from "core/contexts/auth/auth";
import { useLocation } from 'react-router-dom';
import {
  getConversations,
  getGroups,
  getConversationsByID
} from "modules/agentMySecurity/services/embeddingsService";
import { getConversationsFromApi } from "modules/chat/services/chatService";


// Define sort types
type SortColumn = any;
type SortDirection = 'asc' | 'desc' | null;

export default function AdminConversations() {
    const [conversations, setConversations] = useState<Conversation[]>([]);
    const [filteredConversations, setFilteredConversations] = useState<Conversation[] | null>(null);
    const [copyOfSearchValue, setCopyOfSearchValue] = useState("");
    const [sortColumn, setSortColumn] = useState<SortColumn>(null);
    const [sortDirection, setSortDirection] = useState<SortDirection>(null);
    const location = useLocation();
    const ID = location.state?.ID;
    const { checkAMSToken } = useContext(AuthContext);

    useEffect(() => {
        async function fetchConversations() {
            try {
                let response = await getConversationsByID(ID);
                setConversations(response);
            } catch (error) {
                setConversations([]);
            }
        }

        fetchConversations();

    }, []);


        /**
         * Apply sorting whenever sort parameters change*/

        useEffect(() => {
            if (!sortColumn || !sortDirection) {
                return;
            }
    
            const dataToSort = [...(filteredConversations === null ? conversations : filteredConversations)];
    
            const sortedData: any = dataToSort.sort((a, b) => {
                const valA = a._id[sortColumn] ? String(a._id[sortColumn]).toLowerCase() : a[sortColumn] ? String(a[sortColumn]).toLowerCase() : "";
                const valB = b._id[sortColumn] ? String(b._id[sortColumn]).toLowerCase() : b[sortColumn] ? String(b[sortColumn]).toLowerCase() : "";
    
                if (valA < valB) {
                    return sortDirection === 'asc' ? -1 : 1;
                }
    
                if (valA > valB) {
                    return sortDirection === 'asc' ? 1 : -1;
                }
    
                return 0;
            });
    
            setFilteredConversations(filteredConversations === null ? sortedData : sortedData);
        }, [sortColumn, sortDirection]);

    const handleUsersDelete = (deletedKeyId) => {
        if (filteredConversations !== null) {
        setFilteredConversations(prevKeys => {
            if (prevKeys === null) return null;
            return prevKeys.filter(key => key._id !== deletedKeyId);
        });
        }
        setConversations(prevKeys => prevKeys.filter(key => key._id !== deletedKeyId));
  };     

    /**
     * Handle column header click to sort
     */
    const handleSort = (column: SortColumn) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    };

    const getSortIcon = (column: SortColumn) => {
        if (sortColumn !== column) {
            return null;
        }
        return sortDirection === 'asc' ? <ArrowUpwardIcon fontSize="small" className="ms-1" />
            : <ArrowDownwardIcon fontSize="small" className="ms-1" />;
    };

    const handleFilterData = (newKeys, b, c) => {
        setFilteredConversations(newKeys);
        setSortColumn(null);
        setSortDirection(null);
    };

    const handleClearFilter = () => {
        setFilteredConversations(null);
    };

    return (
        <SimpleTableContainer elevation={1} columns={3}>
            {/* Data Search */}
            <div className="pb-3 d-flex justify-content-between align-items-center">
                <h5>Conversations</h5>
                <AdvanceSearch
                    initialData={conversations}
                    setFilteredData={handleFilterData}
                    clearFilteredData={handleClearFilter}
                    setCopyOfSearchValue={setCopyOfSearchValue}
                />
            </div>


            <div aria-label="collapsible table">
                <div style={{ borderRadius: "5px 5px 0 0" }} className="outer-header-container">
                    <div className="row-items row-headers">
                        <p className="header-item d-flex align-items-center" onClick={() => handleSort('user')} style={{ cursor: 'pointer' }}>
                            ID {getSortIcon('id')}
                        </p>
                        <p className="header-item d-flex align-items-center" onClick={() => handleSort('model')} style={{ cursor: 'pointer' }}>
                            Model {getSortIcon('model')}
                        </p>
                        <p className="header-item d-flex align-items-center" onClick={() => handleSort('created')} style={{ cursor: 'pointer' }}>
                            Created At {getSortIcon('created')}
                        </p>
                    </div>
                </div>
                <div style={{ borderRadius: "0 0 5px 5px", minHeight: "406px" }} className="outer-row-container">
                    {(filteredConversations === null ? conversations : filteredConversations)?.length > 0 ? (
                        filteredConversations === null ? (
                            <>
                                {conversations.map((conversation) => (
                                    <AdminConversationRow onDelete={handleUsersDelete} key={uuid4()} conversation={conversation} />
                                ))}
                            </>
                        ) : (
                            <>
                                {filteredConversations.map((conversation) => (
                                    <AdminConversationRow onDelete={handleUsersDelete} key={uuid4()} conversation={conversation} />
                                ))}
                            </>
                        )
                    ) : (
                        <NoResultsFound searchTerm={filteredConversations !== null ? copyOfSearchValue : ""} />
                    )}
                </div>

            </div>
        </SimpleTableContainer>
    );
}